import type { DeliverableAggregate, CampaignDeliverablesTotals } from '../types/deliverable.types';

export function calculateDeliverablesTotals(
  aggregates: DeliverableAggregate[]
): CampaignDeliverablesTotals {
  return aggregates.reduce(
    (acc, agg) => ({
      posts: acc.posts + (agg.post_count || 0),
      views: acc.views + (agg.total_views || 0),
      likes: acc.likes + (agg.total_likes || 0),
      comments: acc.comments + (agg.total_comments || 0),
      shares: acc.shares + (agg.total_shares || 0),
      engagement: acc.engagement + (agg.total_engagement || 0),
    }),
    { posts: 0, views: 0, likes: 0, comments: 0, shares: 0, engagement: 0 }
  );
}

export function formatContentTypes(types: string[] | null, postCount?: number): string {
  if (!types || types.length === 0) {
    if (postCount && postCount > 0) {
      return `${postCount} post${postCount > 1 ? 's' : ''}`;
    }
    return '-';
  }

  // If there is only one distinct content type and postCount is provided,
  // use postCount so that aggregate queries returning DISTINCT types
  // properly reflect the full number of items (e.g. 2 reels instead of 1 reel).
  if (postCount !== undefined && postCount > 0 && types.length === 1) {
    const type = types[0];
    return `${postCount} ${type}${postCount > 1 ? 's' : ''}`;
  }

  const typeCounts: Record<string, number> = {};
  types.forEach((type) => {
    typeCounts[type] = (typeCounts[type] || 0) + 1;
  });

  const totalTypesCount = Object.values(typeCounts).reduce((sum, c) => sum + c, 0);

  // If multiple distinct types exist and total postCount is greater than the array length,
  // display the total post count with the types summary.
  if (postCount !== undefined && postCount > totalTypesCount) {
    return `${postCount} posts (${types.join(', ')})`;
  }

  return Object.entries(typeCounts)
    .map(([type, count]) => `${count} ${type}${count > 1 ? 's' : ''}`)
    .join(' + ');
}
